import { render, staticRenderFns } from "./bridgeProfileForm.vue?vue&type=template&id=526bf54f&scoped=true"
import script from "./bridgeProfileForm.vue?vue&type=script&lang=js"
export * from "./bridgeProfileForm.vue?vue&type=script&lang=js"
import style0 from "./bridgeProfileForm.vue?vue&type=style&index=0&id=526bf54f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526bf54f",
  null
  
)

export default component.exports